import { getBuildingFromInvoice } from '../../services/orders'
import { GetBuildingFromInvoice } from '../interfaces/place-order.interface'
import { useSentryQuery } from '../useSentryQuery'
import { useAuthHook } from './auth.hooks'

export const useGetBuildingFromInvoice = () => {
    const { data: userData } = useAuthHook()

    return useSentryQuery({
        queryKey: ['getBuildingFromInvoice', userData],
        queryFn: async ({ signal }) => {
            const data = await getBuildingFromInvoice({ signal })
            const buildings: {
                [key: string]: {
                    label: string
                    value: string
                } & Partial<GetBuildingFromInvoice>
            } = {
                Blank: { label: 'Blank', value: 'Blank' },
            }
            const units: {
                [key: string]: {
                    label: string
                    value: string
                    isHidden: boolean
                } & Partial<GetBuildingFromInvoice>
            } = {}
            data.forEach((item) => {
                const addrArray = item.DMH_SHADDR2.split('#')
                const buildingValue = addrArray[0].replace(/ /g, '')
                const buildingLabel = addrArray[0]
                buildingValue.length
                    ? (buildings[buildingValue] = {
                          label: buildingLabel,
                          value: buildingValue,
                          ...item,
                      })
                    : (buildings['Blank'] = {
                          label: 'Blank',
                          value: 'Blank',
                          ...item,
                      })

                addrArray[1].length &&
                    (units[addrArray[1]] = {
                        label: addrArray[1],
                        value: addrArray[1],
                        isHidden: false,
                        ...item,
                    })
            })

            const allBuildings = [
                { label: 'Select All', value: 'all' },
                ...Object.values(buildings),
            ]

            const allUnits = [
                { label: 'Select All', value: 'all' },
                ...Object.values(units),
            ]

            return {
                buildings: allBuildings,
                units: allUnits,
            }
        },
        staleTime: 180000,
    })
}
